import InfoIcon from '@mui/icons-material/Info';
import { InputLabel, SelectChangeEvent, Stack, StandardTextFieldProps, TextField, Tooltip } from '@mui/material';
import * as React from 'react';
import { ReactNode } from 'react';
import variable from '../style/variable';

interface IInputTextProps extends StandardTextFieldProps {
    inputLabel?: string;
    textTooltip?: string | ReactNode;
    hidden?: boolean;
    required?: boolean;
    isNumber?: boolean;
    customValue?: any;
    customOnChange?: any;
}

const InputText = (props: IInputTextProps) => {
    const [inputValue, setInputValue] = React.useState(props.customValue ?? '');

    React.useEffect(() => setInputValue(props.customValue), [props.customValue]);

    const handleInputChange = (e: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        let r = e.target.value;
        let t = r.replace(/\,/g, '.');
        const isValidNumber = /^-?(([0-9]*)|(([0-9]*)\.([0-9]*)))$/gm.test(t);
        if (isValidNumber) {
            setInputValue(t);
            e.target.value = t;
            props.customOnChange(e);
        }
    };

    return (
        !props.hidden && (
            <Stack padding={'0.3rem 0rem'} spacing={0.5}>
                {props.textTooltip ? (
                    <Stack direction={'row'} spacing={1} alignItems={'center'}>
                        <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                            {props.inputLabel}
                        </InputLabel>
                        <Tooltip title={props.textTooltip}>
                            <InfoIcon style={{ fill: variable.green }} fontSize='small' />
                        </Tooltip>
                    </Stack>
                ) : (
                    <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                        {props.inputLabel}
                    </InputLabel>
                )}
                {props.isNumber ? (
                    <TextField value={inputValue} type='text' onChange={handleInputChange} {...props} />
                ) : (
                    <TextField value={props.customValue} onChange={props.customOnChange} type='text' {...props} />
                )}
            </Stack>
        )
    );
};

export default InputText;
